import React from 'react'
import classNames from 'classnames'

export default function SubSidebar({
    children
}) {

    const Classes = classNames({
        'bg-extralightprimary lg:bg-white relative border-r border-line w-full lg:w-200 left-0 top-0 lg:h-no-header z-100 transition-all duration-200 overflow-auto drop-shadow-sidebar': true,
    })

    return (
        <div className={Classes}>
            {children}
        </div>
    )
}
